export default __webpack_public_path__ + "static/media/Axe of the Red Tide.f05fc3b8.jpg";